import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getRolesLista = async () => {
    const res = await getData('/roles');
    return res
}

export const getRolesPanel = async (searchTerm, page, perPage) => {
    let queryParams = [];
    if (searchTerm) {
        queryParams.push(`rol_descripcion=${encodeURIComponent(searchTerm || '')}`);
    }
    if (page) {
        queryParams.push(`page=${encodeURIComponent(page || 1)}`);
    }
    if (perPage) {
        queryParams.push(`perPage=${encodeURIComponent(perPage || 10)}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';
    return await getData("/roles", queryString);
};

export const getRolById = async (id) => {
    const res = await getData(`/roles/${id}`)
    return res
}

 
export const postRol = async (body) => {
    const res = await postData('/roles', body)
    return res
}

export const patchRol = async (id, body) => {
    const res = await patchData(`/roles/${id}`, body)
    return res
}

export const deleteRol = async (id) => {
    const res = await deleteData(`/roles/${id}`)
    return res
}